import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/routing/ProtectedRoute';
import RoleRoute from './components/routing/RoleRoute';
import { ROLES } from './models/roles';

import LoginView from './views/auth/LoginView';
import RootRedirect from './views/RootRedirect';
import UnauthorizedView from './views/UnauthorizedView';
import NotFoundView from './views/NotFoundView';
import ProfileView from './views/shared/ProfileView';

import DataEntryDashboard from './views/dataEntry/DataEntryDashboard';
import FormsListView from './views/dataEntry/FormsListView';
import SurveyCaptureView from './views/dataEntry/SurveyCaptureView';
import MyRecordsView from './views/dataEntry/MyRecordsView';
import HouseRegistrationView from './views/dataEntry/HouseRegistrationView';
import HousesListView from './views/dataEntry/HousesListView';
import VisitCaptureView from './views/dataEntry/VisitCaptureView';
import HouseFormStepView from './views/dataEntry/HouseFormStepView';

import AnalystDashboard from './views/analyst/AnalystDashboard';
import ReportsView from './views/analyst/ReportsView';
import ActivityView from './views/analyst/ActivityView';

import AdminDashboard from './views/admin/AdminDashboard';
import UsersView from './views/admin/UsersView';
import FormsManagementView from './views/admin/FormsManagementView';

import './styles/variables.css';
import './styles/global.css';
import './styles/dashboard.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginView />} />
          <Route path="/unauthorized" element={<UnauthorizedView />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/profile" element={<ProfileView />} />

            <Route element={<RoleRoute allowedRoles={[ROLES.DATA_ENTRY]} />}>
              <Route path="/data-entry" element={<DataEntryDashboard />} />
              <Route path="/data-entry/house-registration" element={<HouseRegistrationView />} />
              <Route path="/data-entry/houses" element={<HousesListView />} />
              <Route path="/data-entry/houses/:houseId/visit" element={<VisitCaptureView />} />
              <Route path="/data-entry/houses/:houseId/forms/:slug" element={<HouseFormStepView />} />
              <Route path="/data-entry/forms" element={<FormsListView />} />
              <Route path="/data-entry/forms/:formId" element={<SurveyCaptureView />} />
              <Route path="/data-entry/records" element={<MyRecordsView />} />
            </Route>

            <Route element={<RoleRoute allowedRoles={[ROLES.ANALYST]} />}>
              <Route path="/analyst" element={<AnalystDashboard />} />
              <Route path="/analyst/reports" element={<ReportsView />} />
              <Route path="/analyst/activity" element={<ActivityView />} />
            </Route>

            <Route element={<RoleRoute allowedRoles={[ROLES.ADMIN]} />}>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/users" element={<UsersView />} />
              <Route path="/admin/forms" element={<FormsManagementView />} />
            </Route>
          </Route>

          <Route path="*" element={<NotFoundView />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
